module.exports = __webpack_public_path__ + "img/Z60Q_06.5ca51383.jpg";